export default __webpack_public_path__ + "static/silver-ce6293cadca995613444f3b213dc9b27.png";